"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerMaritialStatus = void 0;
var CustomerMaritialStatus;
(function (CustomerMaritialStatus) {
    CustomerMaritialStatus["Single"] = "solteiro";
    CustomerMaritialStatus["Married"] = "casado-brasileiro-nato";
    CustomerMaritialStatus["MarriedNaturalized"] = "casado-brasileiro-naturalizado";
    CustomerMaritialStatus["MarriedForeign"] = "casado-estrangeiro";
    CustomerMaritialStatus["Divorced"] = "divorciado";
    CustomerMaritialStatus["StableUnion"] = "uniao-estavel";
    CustomerMaritialStatus["Unmarried"] = "desquitado";
    CustomerMaritialStatus["Widower"] = "viuvo";
})(CustomerMaritialStatus = exports.CustomerMaritialStatus || (exports.CustomerMaritialStatus = {}));
//# sourceMappingURL=CustomerMaritialStatus.js.map